import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, BookOpen, Users, ShoppingBag, BarChart2, X, LogOut, ClipboardList, Video, Library, UserCheck, Bell, FileSignature, WalletCards } from "lucide-react";

const ShareIcon = ({ size = 18 }) => (
  <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
  </svg>
);

const links = [
  { to: "/institute", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/institute/courses", label: "Courses", icon: BookOpen },
  { to: "/institute/users", label: "Users", icon: Users },
  { to: "/institute/admission", label: "Offline Admission", icon: FileSignature },
  { to: "/institute/parent-links", label: "Parent Links", icon: UserCheck },
  { to: "/institute/orders", label: "Orders", icon: ShoppingBag },
  { to: "/institute/exams", label: "Exams", icon: ClipboardList },
  { to: "/institute/live-classes", label: "Live Classes", icon: Video },
  { to: "/institute/books", label: "Digital Library", icon: Library },
  { to: "/institute/broadcast", label: "Broadcast Alerts", icon: Bell },
  { to: "/institute/analytics", label: "Detailed Analytics", icon: BarChart2 },
  { to: "/institute/marketing", label: "Social Marketing", icon: ShareIcon },
  { to: "/institute/billing", label: "Billing & Plan", icon: WalletCards },
];


export default function InstituteSidebar({ open, onClose }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <>
      {/* Overlay for mobile */}
      {open && (
        <div
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`fixed left-0 top-0 z-40 flex h-full w-[min(18rem,86vw)] transform flex-col bg-slate-950 text-white shadow-2xl transition-transform duration-300 lg:w-64 lg:shadow-none
          ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        {/* Logo */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-slate-800">
          <div className="flex items-center gap-2">
            <div className="bg-blue-600 p-1.5 rounded-lg">
              <BarChart2 size={20} className="text-white" />
            </div>
            <span className="font-extrabold text-lg tracking-tight">Institute Panel</span>
          </div>
          <button onClick={onClose} className="rounded-lg p-2 text-slate-400 hover:bg-slate-900 hover:text-white lg:hidden">
            <X size={20} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 py-6 space-y-1 overflow-y-auto custom-scrollbar">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-semibold transition-all ${isActive
                  ? "bg-indigo-600 text-white shadow-lg shadow-indigo-600/25"
                  : "text-slate-400 hover:bg-slate-900 hover:text-white"
                }`
              }
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Logout */}
        <div className="px-3 pb-6">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-semibold text-red-400 transition-all hover:bg-red-950/50 hover:text-red-300"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>
    </>
  );
}
